import { FunctionComponent } from 'react';
import ButtonLink from '../../../../../../ButtonLink';
import { useOrderCheckoutContext } from '../../../../../CheckoutContext/OrderContext';
import styles from './styles.module.scss';
import RightToBracketSolidIcon from '../../../../../../Icons/RightToBracketSolidIcon';
import { useOrderLink } from '../../../../../../../hooks/useOrderLink';

type AccessCourseButtonProps = {
    orderId?: string;
};

export const AccessCourseButton: FunctionComponent<AccessCourseButtonProps> = ({ orderId }) => {
    const { course, educator } = useOrderCheckoutContext();

    const orderLink = useOrderLink({
        educatorSlug: educator.slug,
        courseSlug: course.slug,
        orderId: orderId,
    });

    if (!orderId) {
        return null;
    }

    return (
        <ButtonLink
            preset="primary"
            href={orderLink.href}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
        >
            <RightToBracketSolidIcon />
            Access {course.keyword || 'Course'}
        </ButtonLink>
    );
};
